<template>
  <router-view v-if="template.isloaded"></router-view>
</template>
<script>
// import {mapState, mapActions} from 'vuex';
import $ from "jquery";
import VConsole from "vconsole";

import { interact, ck, cr, URLS } from "fire-wind-water";
import { setDomain } from "../stempcore/src/sbase";

import { getGlobalUserId } from "../stempcore/src/core/client";
import { $subscriber } from "fire-wind-water";
import webinarService from "./services/webinar";
import comonService from "./services/comonService";
import { tenantId, webinarId, instanceId } from "./common/sbase";
import wechat from "./common/weChat";
import URL from "./assets/conf/setting.json";
import user from "./common/user";
import longVariable from "./common/longVariable";
import appVue from "./common/appVue";
import { validateState } from "@/common/joinMeeting";
import { mixinsTemplate } from "./common/mixinsTemplate";
import { isInWechatAuth, initJsSdk, agentType } from "../stempcore/src/sbase";

export default {
  name: "App",
  mixins: [mixinsTemplate],
  data() {
    return {
      //是否为微信浏览器
      isWeChatBrowser:
        navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1,
      webinarInfo: {},
      userInfo: {},
      //是否为手机
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)
    };
  },
  created() {
    $("body").append('<div id="s-sk-loading"> </div>');
    window.$sk.loading.show();
    if (window.location.href.indexOf("VCONSOLE=1") > -1) {
      var vConsole = new VConsole();
    }
    if (window.location.href.indexOf("isSetting") > -1) {
      $("body").append('<div class="m-overall"></div>'); //增加蒙层
      const meetingInfo = longVariable.meetingInfo;
      const recommendList = longVariable.recommendList;
      const userInfo = longVariable.userInfo;
      const wapPackBackVideoList = longVariable.wapPackBackVideoList;
      const pcPackBackVideoList = longVariable.pcPackBackVideoList;
      $subscriber.emit("webinarInfo", meetingInfo);
      $subscriber.emit("userInfo", userInfo);
      $subscriber.emit("recommendList", recommendList);
      $subscriber.emit("wapPackBackVideoList", wapPackBackVideoList);
      $subscriber.emit("pcPackBackVideoList", pcPackBackVideoList);
      window.$sk.loading.hide();
      //  新增回看 逻辑判断 1012
    } else {
      this.init();
      $subscriber.subscribe("onUserNameShow", () => {
        $subscriber.emit("showSetUserName", true);
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
      });
      $subscriber.subscribe("error", data => {
        $subscriber.emit("showPopup", { message: data });
      });
      $subscriber.subscribe("webinarReload", () => {
        this.init();
      });
      $subscriber.subscribe("onUnLimitRegistration", data => {
        if (data.isUnLimit) {
          if (
            !this.webinarInfo.unLimit &&
            !data.openId &&
            !this.webinarInfo.needLogin &&
            this.webinarInfo.needRegistration &&
            data.isRegistration
          ) {
            //重置globalUserId
            ck.cookie("globalUserId", null, {
              domain: window.$sk.config.domain,
              path: "/"
            });
            getGlobalUserId();
            return user.userLoad(this.webinarInfo);
          }
        }
      });
      $subscriber.subscribe("getVideoPlayback", meetingInfo => {
        this.service
          .getVideoPlayback({
            tenantId: Number(meetingInfo.tenantId),
            instanceId: meetingInfo.instanceId,
            webinarId: meetingInfo.webinarId
          })
          .subscribe(videoList => {
            const { items } = videoList.content;
            let videoPlayBackList = items.sort(function(a, b) {
              return a.orderNum - b.orderNum;
            });
            $subscriber.emit("webinarInfo-videoList", videoPlayBackList);
          });
      });
    }
  },
  methods: {
    init() {
      $("<link>")
        .attr({
          rel: "stylesheet",
          type: "text/css",
          href:
            URL.template.templateUrl + "redpacket/hongbao/assets/css/index.css"
        })
        .appendTo("head");
      $("<script>")
        .attr({
          rel: "stylesheet",
          type: "text/javascript",
          src: URL.template.templateUrl + "redpacket/hongbao/index.js"
        })
        .appendTo("head");
      setDomain(window.$sk.config.domain); //设置domain域名
      if (!ck.cookie("globalUserId")) {
        getGlobalUserId(); // 生成匿名用户
      }
      this.getTenantPerm().then(data => {
        $subscriber.emit("tenantPermInfo", data);
      });
      // window.$sk.webinar.skMeetingEvent({ type:'AppVueInit', data:{} });
      this.getServerTime()
        .then(schemaId => {
          // this.checkSession(schemaId);
          return this.getMeeting();
        })
        .then(meetingRes => {
          this.webinarInfo = meetingRes;
          //微信授权
          window.$sk.template.update({
            type: "anth",
            data: {
              weChatId: this.webinarInfo.weChatId,
              scope: "snsapi_userinfo"
            }
          });
          //引入sk
          window.$sk.template.module(this);
          //向sk注入监听
          this.injectionSK();
        });
      if (agentType() == "weChat") {
        let tenantId = URLS.getURL("tenantId");
        const apiUrl = URL.template.api.gateway.general;
        window.$swxsdk.initWxSdk({ tenantId }, apiUrl);
        $subscriber.subscribe("webinarInfo", data => {
          // 获取到分享信息后，调用
          let coverImageUrl =
            data.weChatId && data.shareCoverUrl
              ? data.shareCoverUrl.replace("http://", "https://")
              : "https:" + data.logoRealPath;
          try {
            if (cr.isEmptyObject(data.title) === false)
              if (data.canShare != 1) {
                window.$swxsdk.on(
                  "hideMenuList",
                  {
                    menuList: [
                      "menuItem:share:appMessage",
                      "menuItem:share:timeline",
                      "menuItem:share:qq",
                      "menuItem:share:weiboApp",
                      "menuItem:share:facebook",
                      "menuItem:share:QZone"
                    ]
                  },
                  function(result) {
                    console.log(result);
                  }
                );
                return;
              }

            window.$swxsdk.on(
              "sharer",
              {
                title:
                  data.weChatId && data.shareTitle
                    ? data.shareTitle
                    : data.title, // 分享标题
                desc:
                  data.weChatId && data.shareSummary
                    ? data.shareSummary
                    : data.title, // 分享描述
                link: window.location.href.replace("&markPreview=1", ""), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: coverImageUrl // 分享图标
              },
              function(result) {
                console.log(result);
              }
            );
            window.$swxsdk.on(
              "sharer_friends",
              {
                title:
                  data.weChatId && data.shareTitle
                    ? data.shareTitle
                    : data.title, // 分享标题
                desc:
                  data.weChatId && data.shareSummary
                    ? data.shareSummary
                    : data.title, // 分享描述
                link: window.location.href.replace("&markPreview=1", ""), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: coverImageUrl // 分享图标
              },
              function(result) {
                console.log(result);
              }
            );
          } catch (e) {
            console.log(e);
          }
        });
      } else if (agentType() == "wxWork") {
        $subscriber.subscribe("webinarInfo", data => {
          initJsSdk(URLS.getURL("tenantId"), () => {
            const url = URLS.removeSearchParam(
              window.location.href,
              "token",
              "retCode",
              "puzzleFlag"
            );
            const info = data;
            const shareInfo = {
              title: info.shareTitle, // 分享标题,
              desc: info.shareSummary, // 分享描述,
              link:
                URL.weworkCustomerJumpUrl.replace(
                  "{$tenantId}",
                  data.tenantId
                ) + encodeURIComponent(url), //这里需要改
              imgUrl: info.shareCoverUrl // 分享图标
            };
            shareInfo.link = window.$swxsdk.urlAddChannel(shareInfo.link);
            window.wx.onMenuShareAppMessage({ ...shareInfo });
            window.wx.onMenuShareWechat({ ...shareInfo });
            window.wx.onMenuShareTimeline({ ...shareInfo });
          });
        });
      }
      //开启监听
      appVue.ListenDataChange();
    },

    skUserInit(e) {
      this.initMeeting();
    },
    skAuthEnd(wechatInfo) {
      console.log(" 微信 skAuthEnd 授权之后 返回参数 ", wechatInfo);
      let info = {
        browseInfo: interact.browseInfo,
        sess: ck.cookie(`smarketMember_` + this.webinarInfo.schemaId)
          ? ck.cookie(`smarketMember_` + this.webinarInfo.schemaId).session
          : "",
        tenantId: this.webinarInfo.tenantId,
        webinarId: this.webinarInfo.webinarId,
        openId: wechatInfo.tokenInfo.original.openid,
        instanceId: this.webinarInfo.instanceId,
        joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
        globalUserId: ck.cookie("globalUserId") || "",
        // markCode 与 marketingSess 为用于统计的埋点相关参数
        markCode: URLS.getURL("markCode") || "",
        markType: URLS.getURL("markType") || "",
        marketingSess: ck.cookie("marketingSess") || "",
        tc: URLS.getURL("tc") || "" // 渠道追踪码
      };
      if (window.location.href.indexOf("meetingInfo") > -1) {
        comonService.activeRecords(info);
      }
    },
    initMeeting() {
      let webinarInfo = this.webinarInfo;
      window.$sk.template.update({
        type: "webinar",
        data: {
          type: webinarInfo.replaySwitch === 1 ? "lookBack" : "live", // 直播 与 回看
          page:
            window.location.href.indexOf("meetingInfo") > -1
              ? "meetingInfo"
              : "meeting", //页面 meeting  meetinginfo
          needJump:
            window.location.href.indexOf("meetingInfo") > -1 ? false : true, //需要跳转吗 meetingInfo跳页 meeting跳页
          webinarId: webinarInfo.webinarId,
          instanceId: webinarInfo.instanceId,
          tenantId: webinarInfo.tenantId,
          needLogin: webinarInfo.needLogin,
          needRegistration: webinarInfo.needRegistration,
          unLimit: webinarInfo.unLimit,
          isReleased: webinarInfo.isReleased,
          isClosed: webinarInfo.isClosed,
          isOpen: webinarInfo.isOpen,
          replaySwitch: webinarInfo.replaySwitch,
          registrationFormId: webinarInfo.registrationFormId, //注册表单id
          customFormId: URLS.getURL("customFormId"), //报名表单id
          weChatId: webinarInfo.weChatId
        }
      });
    },
    //注入sk监听
    injectionSK() {
      const _this = this;
      window.$sk.webinar.module({
        skMeetingLinkEnd(res) {
          console.log(
            `%c sk 用户信息 与 会议信息都初始化 后模板接收到`,
            "color:blue",
            res
          );
          console.log(
            `%c 当前页面是不是mettinginfo页：`,
            "color:blue",
            window.location.href.indexOf("/meetingInfo") > -1 ? true : false
          );
          let userInfo = window.$sk.webinar.get().user;
          $subscriber.emit("userInfo", userInfo);
          $subscriber.emit("signUpTextStatus", userInfo.signUpTextStatus);
          setTimeout(() => {
            $subscriber.emit("initSkSDK", true);
          }, 10);
          if (_this.webinarInfo.replaySwitch == 1) {
            _this.getVideoPlayBackList(_this.webinarInfo);
          }
          window.$sk.loading.hide();
        },
        // 用户状态发生改变
        skWebinarUserChange(data) {
          console.log("用户状态发生改变", data);
          let nowData = data[0];
          switch (nowData.type) {
            case "kickOut":
              this.abnormalState(nowData);
              break;
            case "setUserName":
              $subscriber.emit("setUserName", nowData.name);
              break;
            case "change":
              $subscriber.emit("userInfo", nowData.data);
              break;
          }
        },
        //AbnormalState 处理kickOut  异常状态
        abnormalState(data) {
          console.log(data);

          window.$sk.loading.hide();
          const popMessage = data.data.message;
          const webianr = window.$sk.webinar.get().meetingInfo;
          const userInfo = window.$sk.webinar.get().user;
          $subscriber.emit("signUpTextStatus", userInfo.signUpTextStatus);
          if (window.location.href.indexOf("/meetingInfo") > -1) {
            //若是meeting 跳出
            return;
          }
          const returnUrl = window.location.href.replace(
            "/meetingInfo",
            "/meeting"
          );
          if (popMessage == "很抱歉，您来晚了，本场会议已经关闭") {
            setTimeout(() => {
              window.$sk.goto(
                window.location.href.replace("/meeting", "/meetingInfo")
              );
            }, 2000);
            return;
          }
          //只负责 报名审核没通过
          if (!validateState(webianr, userInfo, true)) {
            console.log("报名审核没通过");
            //状态不对  返回 meetingInfo
            let returnUrl = window.location.href;
            if (!webianr.isOpen || webianr.isClosed) {
              returnUrl = window.location.href.replace(
                "/meeting",
                "/meetingInfo"
              );
            }
            setTimeout(() => {
              window.$sk.goto(returnUrl);
            }, 1000);
            return;
          }
          if (webianr.needLogin && !userInfo.isLogin && !webianr.unLimit) {
            $subscriber.emit("showPopup", { message: data.data.message });
            setTimeout(() => {
              window.$sk.goto(
                webianr.loginUrl +
                  "sourceKey=" +
                  URLS.getURL("sourceKey") +
                  "&backUrl=" +
                  encodeURIComponent(returnUrl)
              );
            }, 3000);
          } else if (
            webianr.needRegistration &&
            !userInfo.isRegistration &&
            !webianr.unLimit
          ) {
            $subscriber.emit("showPopup", { message: data.data.message });
            window.$sk.goto(
              webianr.goToSignUpUrl +
                "&backUrl=" +
                encodeURIComponent(returnUrl)
            );
          } else if (
            webianr.needLogin &&
            !userInfo.isLogin &&
            webianr.needRegistration &&
            !userInfo.isRegistration &&
            !webianr.unLimit
          ) {
            $subscriber.emit("showPopup", { message: data.data.message });
            window.$sk.goto(
              webianr.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(webianr.goToSignUpUrl)
            );
          }
        }
      });
    },
    //获取互动参数
    getTenantPerm() {
      let defer = $.Deferred();
      this.service
        .getTenantPerm({
          tenantId: tenantId
        })
        .subscribe(data => {
          if (data && data.content) {
            defer.resolve(data.content);
          }
        });
      return defer.promise();
    },
    // 获取视频回放列表
    getVideoPlayBackList(meetingInfo) {
      this.service
        .getVideoPlayback({
          tenantId: Number(meetingInfo.tenantId),
          instanceId: meetingInfo.instanceId,
          webinarId: meetingInfo.webinarId
        })
        .subscribe(videoList => {
          const { items } = videoList.content;
          let videoPlayBackList = items.sort(function(a, b) {
            return a.orderNum - b.orderNum;
          });
          $subscriber.emit("webinarInfo-videoList", videoPlayBackList);
        });
    },
    // 获取服务器时间

    getServerTime() {
      let defer = $.Deferred();
      this.service
        .getServerTime({
          webinarId: webinarId
        })
        .subscribe(data => {
          this.webinarInfo.serverTime = data.content.time * 1000;
          this.webinarInfo.tenantId = data.content.tenantId;
          defer.resolve(data.content.schemaId);
        });
      return defer.promise();
    },
    //获取会议信息
    getMeeting() {
      let defer = $.Deferred();
      const self = this;
      this.service
        .getMeeting({
          tenantId: tenantId,
          webinarId: webinarId
        })
        .subscribe(data => {
          if (data.result === 0 && data.content) {
            appVue.setMettingInfo(
              this.webinarInfo,
              data.content.webinarInfo,
              callbackWebinarInfo => {
                this.webinarInfo = callbackWebinarInfo;
              }
            );
            this.getPosterShareStatus();
            if (!ck.cookie("globalUserId")) {
              getGlobalUserId();

              if (
                this.isWeChatBrowser &&
                this.webinarInfo.weChatId &&
                !this.webinarInfo.unLimit &&
                isInWechatAuth(this.webinarInfo.tenantId)
              ) {
                wechat.weChatLoad(this.webinarInfo.weChatId, false).then(
                  wechatInfo => {
                    let info = {
                      browseInfo: interact.browseInfo,
                      sess: ck.cookie(
                        `smarketMember_` + this.webinarInfo.schemaId
                      )
                        ? ck.cookie(
                            `smarketMember_` + this.webinarInfo.schemaId
                          ).session
                        : "",
                      tenantId: this.webinarInfo.tenantId,
                      webinarId: this.webinarInfo.webinarId,
                      openId: wechatInfo.tokenInfo.original.openid,
                      instanceId: this.webinarInfo.instanceId,
                      joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
                      globalUserId: ck.cookie("globalUserId") || "",
                      // markCode 与 marketingSess 为用于统计的埋点相关参数
                      markCode: URLS.getURL("markCode") || "",
                      markType: URLS.getURL("markType") || "",
                      marketingSess: ck.cookie("marketingSess") || "",
                      tc: URLS.getURL("tc") || "" // 渠道追踪码
                    };
                    if (window.location.href.indexOf("meetingInfo") > -1) {
                      comonService.activeRecords(info);
                    }
                  },
                  e => {
                    console.log(e);
                  }
                );
              } else {
                let tokenInfo = ck.cookie(
                  "verifyInfo_" + this.webinarInfo.weChatId
                );
                let info = {
                  browseInfo: interact.browseInfo,
                  sess: ck.cookie(`smarketMember_` + this.webinarInfo.schemaId)
                    ? ck.cookie(`smarketMember_` + this.webinarInfo.schemaId)
                        .session
                    : "",
                  tenantId: this.webinarInfo.tenantId,
                  webinarId: this.webinarInfo.webinarId,
                  openId: tokenInfo ? tokenInfo.original.openid : 0,
                  instanceId: this.webinarInfo.instanceId,
                  joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
                  globalUserId: ck.cookie("globalUserId") || "",
                  // markCode 与 marketingSess 为用于统计的埋点相关参数
                  markCode: URLS.getURL("markCode") || "",
                  markType: URLS.getURL("markType") || "",
                  marketingSess: ck.cookie("marketingSess") || "",
                  tc: URLS.getURL("tc") || "" // 渠道追踪码
                };
                if (window.location.href.indexOf("meetingInfo") > -1) {
                  comonService.activeRecords(info);
                }
              }
            } else {
              if (
                this.isWeChatBrowser &&
                this.webinarInfo.weChatId &&
                !this.webinarInfo.unLimit &&
                isInWechatAuth(this.webinarInfo.tenantId)
              ) {
                wechat.weChatLoad(this.webinarInfo.weChatId, false).then(
                  wechatInfo => {
                    let info = {
                      browseInfo: interact.browseInfo,
                      sess: ck.cookie(
                        `smarketMember_` + this.webinarInfo.schemaId
                      )
                        ? ck.cookie(
                            `smarketMember_` + this.webinarInfo.schemaId
                          ).session
                        : "",
                      tenantId: this.webinarInfo.tenantId,
                      webinarId: this.webinarInfo.webinarId,
                      openId: wechatInfo.tokenInfo.original.openid,
                      instanceId: this.webinarInfo.instanceId,
                      joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
                      globalUserId: ck.cookie("globalUserId") || "",
                      // markCode 与 marketingSess 为用于统计的埋点相关参数
                      markCode: URLS.getURL("markCode") || "",
                      markType: URLS.getURL("markType") || "",
                      marketingSess: ck.cookie("marketingSess") || "",
                      tc: URLS.getURL("tc") || "" // 渠道追踪码
                    };
                    if (window.location.href.indexOf("meetingInfo") > -1) {
                      comonService.activeRecords(info);
                    }
                  },
                  () => {}
                );
              } else {
                let tokenInfo = ck.cookie(
                  "verifyInfo_" + this.webinarInfo.weChatId
                );
                let info = {
                  browseInfo: interact.browseInfo,
                  sess: ck.cookie(`smarketMember_` + this.webinarInfo.schemaId)
                    ? ck.cookie(`smarketMember_` + this.webinarInfo.schemaId)
                        .session
                    : "",
                  tenantId: this.webinarInfo.tenantId,
                  webinarId: this.webinarInfo.webinarId,
                  openId: tokenInfo ? tokenInfo.original.openid : 0,
                  instanceId: this.webinarInfo.instanceId,
                  joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
                  globalUserId: ck.cookie("globalUserId") || "",
                  // markCode 与 marketingSess 为用于统计的埋点相关参数
                  markCode: URLS.getURL("markCode") || "",
                  markType: URLS.getURL("markType") || "",
                  marketingSess: ck.cookie("marketingSess") || "",
                  tc: URLS.getURL("tc") || "" // 渠道追踪码
                };
                if (window.location.href.indexOf("meetingInfo") > -1) {
                  comonService.activeRecords(info);
                }
              }
            }
            let cookie = ck.cookie(
              "smarketMember_" + this.webinarInfo.schemaId
            );
            let isLogin = "";
            if (cookie !== "" && cookie != null) {
              isLogin = true;
            } else {
              isLogin = false;
            }
            //只有会场页面才有这个逻辑
            // if (window.location.href.indexOf("/meetingInfo") < 0) {
            //   if (
            //     !this.webinarInfo.isClosed &&
            //     !this.webinarInfo.unLimit &&
            //     this.webinarInfo.needLogin &&
            //     !isLogin
            //   ) {
            //     //用户是否登录
            //     $subscriber.emit("onLoginMeeting");
            //   }
            // }
            defer.resolve(this.webinarInfo);
          } else {
            defer.resolve("err");
          }
        });
      return defer.promise();
    },
    // 获取模板配置信息
    getTemplateConfig(meetingInfo) {
      this.service
        .getTemplateConfig({
          tenantId: tenantId,
          configId:
            interact.isMobile === 1
              ? meetingInfo.templateWapConfigId
              : meetingInfo.templatePcConfigId
        })
        .subscribe(data => {
          if (data.result === 0 && data.content) {
            //            console.log("模板配置>>>>>>>>>>", data.content.configInfo);
            //            this.$store.dispatch("templateInfo", data.content.configInfo);
            cr.each(data.content.configInfo.html, item => {});
          }
        });
    },
    getPosterShareStatus() {
      this.service
        .getPosterStatus({
          tenantId: tenantId,
          moduleId: 2,
          instanceId: instanceId,
          type: "poster",
          hasConfigId: 1
        })
        .subscribe(data => {
          this.webinarInfo.posterStatus =
            data && data.content ? data.content.status : "";
          $subscriber.emit("posterStatus", this.webinarInfo.posterStatus);
          if (data.result == 0 && data.content.status === 1) {
            this.getPosterShareUrl();
          }
        });
    },
    getPosterShareUrl() {
      let params = {
        instanceId: this.webinarInfo.instanceId,
        tenantId: this.webinarInfo.tenantId,
        moduleId: 2,
        type: "poster"
      };
      this.service.getPosterShareUrl(params).subscribe(res => {
        if (res.result == 0) {
          const markType = URLS.getURL("markType");
          const tc = URLS.getURL("tc");
          const userInfo = window.$sk.webinar.get().user;
          let url =
            window.location.protocol +
            res.content.wap.formalUrl +
            "index.html?tenantId=" +
            this.webinarInfo.tenantId +
            "&instanceId=" +
            this.webinarInfo.instanceId +
            "&moduleId=2&weChatId=" +
            (window.location.href.indexOf("pc") > -1
              ? 0
              : this.webinarInfo.weChatId || 0) +
            "&schemaId=" +
            (this.webinarInfo.schemaId || 0) +
            (markType ? "&markType=" + markType : "") +
            (tc ? "&tc=" + tc : "") +
            (userInfo.markCode && userInfo.markCode !== ""
              ? "&markCode=" + userInfo.markCode
              : "") +
            "&le=" +
            (window.location.href.indexOf("meetingInfo") > -1 ? "0" : 1) +
            "#/";
          this.webinarInfo.posterShareUrl = url;
          $subscriber.emit("posterShareUrl", this.webinarInfo.posterShareUrl);
        }
      });
    },
    // 校验session
    checkSession(schemaId) {
      if (ck.cookie(`smarketMember_` + schemaId)) {
        this.service
          .checkSess({
            browseInfo: interact.browseInfo,
            sess: ck.cookie(`smarketMember_` + schemaId).session,
            globalUserId: ck.cookie("globalUserId")
          })
          .then(data => {
            console.log(data);
          });
      }
    }
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        var currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
        var index = this.webinarInfo.posterShareUrl.indexOf("&le=");
        if (index > -1) {
          this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
            this.webinarInfo.posterShareUrl.substring(index, index + 5),
            ""
          );
        }
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&le=" +
            (window.location.href.indexOf("meetinginfo") > -1 ? 0 : 1) +
            "#/"
        );
      },
      false
    );
  }
};
</script>
<style lang="scss"></style>
